<template>
	<v-listbox v-model="localValue" :options="options" />
</template>

<script lang="ts" setup>
import type {SortOption} from "@apptus/esales-api";
import type {Ref} from "vue";
import type {DropdownOption} from "@pkg/shared/types";

interface Sorting {
	sorting: Readonly<Ref<string | undefined>>;
	update: (key: string) => void;
}

const sortOptions = inject<Ref<SortOption[]>>("sortOptions", ref([]));
const {sorting, update} = inject<Sorting>("sorting", {
	sorting: readonly(ref<string>()),
	update: () => {},
});

const localValue = computed<string>({
	get: () => sorting.value || (sortOptions.value[0]?.id ?? ""),
	set: (value) => update(value || (sortOptions.value[0]?.id ?? "")),
});

const options = computed<DropdownOption[]>(() =>
	sortOptions.value.map((option) => ({
		title: option.label,
		value: option.id,
	})),
);
</script>
